module.exports = __webpack_public_path__ + "img/electronic_use_selected.ff0acb55.svg";